import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../../context/AlertContext";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "../../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../../sale/font/Inter_24pt-Bold-normal";
import { useNetwork } from "../../../../../context/NetworkContext";
import AxiosInstance from "../../../../../utils/AxiosInstance";
import uRLs from "../../../../../utils/baseUtils";
import handleError from "../../../../../constants/handleError";
import { useAuth } from "../../../../../context/AuthProvider";
import { usePermission } from "../../../../../context/PermissionContext";
import CashButton from "../../../sale/cashbtn";
import PayLaterButton from "../../../sale/PaylaterBtn";
import QRCode from "qrcode";
import { formatCurrency } from "@heartinz/finance";
import { FormatedSaleData } from "../../../../../utils/print/GlobelSaleData";
import { DownloadIcon, PrinterIcon, ShowIcon } from "../../../../../constants/Icons";
const HalfA4_2 = ({
  isViewData,
  selectedTheme,
  selectedSize,
  downloadbtn = false,
  payment = false,
}) => {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { permission, blockedPermissions, storeSettings, viewOption } =
    usePermission();
  const { isUser, settings } = useAuth();
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [terms, setTerms] = useState([]);
  const [download, setDownload] = useState(false);
  const [print, setPrint] = useState(false);
  const [error, setErrors] = useState({});
  const [isPaySettleModalOpen, setIsPaySettleModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [data, setData] = useState({});
  const globalData = FormatedSaleData(data);
  const cashRef = useRef();
  const paylaterRef = useRef();

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };
  const formatCurrencyINR = (value) => {
    const formatted = Math.abs(value).toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  // new template starts ////// **/////////////////////////////

  const urlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const joinAddress = (...lines) =>
    lines
      .map((l) => l?.trim())
      .filter(Boolean)
      .join(", ");

  //commercial invoice

  const generateinvoiceHalfA4PDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const PADDING = 5;
    const HALF_PAGE_HEIGHT = 140; // Your target cut-off
    const USABLE_WIDTH = pageW - PADDING * 2; // Full width minus left/right padding
    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;
    const centerX = pageW / 2;
    let y = PADDING; // Start at exactly 5mm from the top
    const checkHalfPageOverflow = (currentY, neededSpace = 10) => {
      if (currentY + neededSpace > HALF_PAGE_HEIGHT - PADDING) {
        doc.addPage();
        return PADDING; // Reset Y for new page
      }
      return currentY;
    };

    const invoiceText =
      data.status === "CANCELLED" ? "CANCELLED" : "TAX INVOICE";
    doc.setFontSize(9);
    doc.text(invoiceText, MARGIN_RIGHT, y + 2, { align: "right" });
    if (data?.salefrom?.image) {
      try {
        const imagePath = settings?.saleProfileData?.image
          ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
          : "/assets/images/logo-light.png";
        const logoBase64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(logoBase64);

        const maxWidth = 35;
        const maxHeight = 15;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const finalW = width * ratio;
        const finalH = height * ratio;

        // --- CHANGE HERE: Set logoX to MARGIN_LEFT instead of centering it ---
        const logoX = MARGIN_LEFT;

        doc.addImage(logoBase64, "PNG", logoX, y, finalW, finalH);

        // We don't necessarily want to push y down for the whole page yet
        // so the text can stay aligned with the logo area
        const logoBottom = y + finalH;

        // 2. DISPLAY COMPANY NAME (Still Centered)
        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(10); // Slightly larger for company name
        doc.setTextColor(0);
        doc.text(globalData.salefrom?.title || "", centerX, y + 3, {
          align: "center",
        });

        // 3. DISPLAY ADDRESS (Still Centered)
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(8);
        doc.setTextColor(60, 60, 60);

        const fromAddress = [
          [
            globalData.salefrom?.addressline1,
            globalData.salefrom?.addressline2,
            globalData.salefrom?.district,
            globalData.salefrom?.state,
            globalData.salefrom?.pincode,
          ]
            .filter(Boolean)
            .join(", "),
          [
            globalData.salefrom?.phone
              ? `Ph: ${globalData.salefrom.phone}`
              : "",
            globalData.salefrom?.gstnumber
              ? `GSTIN: ${globalData.salefrom.gstnumber}`
              : "",
          ]
            .filter(Boolean)
            .join(" | "),
        ].filter(Boolean);

        let addrY = y + 6;
        fromAddress.forEach((line) => {
          doc.text(line, centerX, addrY, { align: "center" });
          addrY += 4;
        });

        // Set y to the bottom of whichever is taller: the logo or the address text
        y = Math.max(logoBottom, addrY);
      } catch (e) {
        console.warn("Logo failed", e);
        y += 10; // Fallback spacing if logo fails
      }
    }

    y -= 2;

    doc.setDrawColor(
      selectedTheme?.templateTheme?.borderColor || [200, 200, 200]
    );
    doc.setLineWidth(0.3);
    doc.line(MARGIN_LEFT, y, MARGIN_RIGHT, y);
    y += 3;
    doc.setFontSize(7);
    const invoiceLabel = "Invoice #: ";
    const invoiceValue = `${globalData.saleno || "-"}`;
    const dateLabel = "  |  Date: ";
    const dateValue = `${
      globalData.saledate
        ? DateConverter.ISOToDisplayFormat(globalData.saledate).date
        : "-"
    }`;

    const dateValueW = doc.getTextWidth(dateValue);
    const dateLabelW = doc.getTextWidth(dateLabel);
    const invoiceValueW = doc.getTextWidth(invoiceValue);
    const invoiceLabelW = doc.getTextWidth(invoiceLabel);

    const totalWidth = invoiceLabelW + invoiceValueW + dateLabelW + dateValueW;

    let currentX = MARGIN_RIGHT - totalWidth;
    doc.setFont("Inter-Regular", "normal");
    doc.text(invoiceLabel, currentX, y);
    currentX += invoiceLabelW;

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceValue, currentX, y);
    currentX += invoiceValueW;

    doc.setFont("Inter-Regular", "normal");
    doc.text(dateLabel, currentX, y);
    currentX += dateLabelW;

    doc.setFont("Inter-Bold", "bold");
    doc.text(dateValue, currentX, y);

    y += 2;

    const toDetailsLine = [
      globalData.saleto?.name || "-",
      [
        globalData.saleto?.addressline1,
        globalData.saleto?.addressline2,
        globalData.saleto?.district,
        globalData.saleto?.state,
        globalData.saleto?.pincode,
      ],
      [
        globalData.saleto?.gstnumber
          ? `GSTIN: ${globalData.saleto.gstnumber}`
          : "",
        globalData.saleto?.phone ? `Mobile: ${globalData.saleto.phone}` : "",
      ]
        .filter(Boolean)
        .join(" | "),
    ]
      .filter(Boolean)
      .join("\n");

    // y += 2;
    const colWidth = pageW - PADDING * 2;

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.text("Customer Details:", PADDING, y);
    const wrappedBilling = doc.splitTextToSize(toDetailsLine, colWidth - 5);

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    doc.text(wrappedBilling, PADDING, y + 4);

    const billingHeight = wrappedBilling.length * 3.5;
    y += Math.max(billingHeight) + 2;

    const leftBoxX = 8;

    /* -------------------------------------------------
     PRODUCT TABLE1
  ------------------------------------------------- */
    autoTable(doc, {
      startY: y + 1,
      theme: "plain",
      rowPageBreak: "avoid",

      margin: {
        top: PADDING,
        left: PADDING,
        right: PADDING,
        bottom: pageH - HALF_PAGE_HEIGHT + PADDING,
      },
      pageBreak: "auto",
      styles: {
        font: "Inter-Regular",
        fontSize: 7,
        cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
        valign: "middle",
        lineWidth: 0,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        textColor: [0, 0, 0],
      },
      headStyles: {
        font: "Inter-Bold",
        fontSize: 8,
        fillColor: selectedTheme?.templateTheme?.primaryColor || [20, 40, 100],
        textColor: selectedTheme?.templateTheme?.foregroundColor || [0, 0, 0],
        lineWidth: { top: 0.5, bottom: 0.5 },
        lineColor: selectedTheme?.templateTheme?.borderColor,
      },
      head: [
        ["#", "Item", "MRP", "Selling Price", "Qty", "Landing Cost", "Amount"],
      ],
      body: globalData.saleitems.map((it, i) => {
        const itemDesc = it.hsnsac
          ? `${it.title}\nHSN: ${it.hsnsac}`
          : it.title;
        return [
          i + 1,
          itemDesc,
          `₹${it.mrp}`,
          `₹${it.baseprice}`,
          `${it.quantity} ${(() => {
            const unitCode = it?.isSecondaryUnit
              ? it?.unitConfig?.secondaryUnitCode
              : it?.unitConfig?.primaryUnitCode;
            return unitCode || "";
          })()}`,
          `₹${it?.lineTotalLandingCost}`, //Pcs
          `₹${it.lineGrandTotal}`,
        ];
      }),
      columnStyles: {
        0: { cellWidth: 10, halign: "center" }, // S.No
        1: { cellWidth: "auto", halign: "left" }, // Flexible Description
        2: { cellWidth: 35, halign: "right" }, // Right-aligned Price
        3: { cellWidth: 30, halign: "right" },
        4: { cellWidth: 20, halign: "right" }, // Right-aligned Price
        5: { cellWidth: 20, halign: "right" },
        6: { cellWidth: 25, halign: "right" }, // Amount
      },
      didParseCell: function (data) {
        if (data.section === "head") {
          data.cell.styles.lineWidth = { top: 0.2, bottom: 0.2 };
          const colId = data.column.index;
          if (colId === 0) data.cell.styles.halign = "center";
          if (
            colId === 2 ||
            colId === 3 ||
            colId === 4 ||
            colId === 5 ||
            colId === 6
          )
            data.cell.styles.halign = "right";

          if (data.column.index === 0) {
            data.cell.styles.lineWidth = {
              ...data.cell.styles.lineWidth,
              left: 0.2,
            };
          }

          if (data.column.index === 6) {
            data.cell.styles.lineWidth = {
              ...data.cell.styles.lineWidth,
              right: 0.2,
            };
          }
        }
        if (data.section === "body") {
          const colId = data.column.index;
          let lines = { bottom: 0 };

          if (colId === 0) {
            lines.left = 0.1;
          }

          if (colId === 6) {
            lines.right = 0.1;
          }
          data.cell.styles.lineWidth = lines;
        }
      },

      didDrawPage: function (data) {
        const finalY = data.cursor.y;
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
        doc.line(PADDING, finalY, pageW - PADDING, finalY); // Bottom horizontal line
      },
    });

    /* -------------------------------------------------
//    TOTALS & GST SECTION (Split Row)
// ------------------------------------------------- */

    y = doc.lastAutoTable.finalY;
    // y = checkHalfPageOverflow(y, 35);
    const isInterState =
      globalData?.salefrom?.statecode &&
      globalData?.saleto?.statecode &&
      globalData?.salefrom?.statecode !== globalData?.saleto?.statecode;

    const summaryData = [
      ["Total Amount Before Tax", `₹${globalData.totalbaseprice}`],
    ];
    if (isInterState) {
      summaryData.push(["IGST ", `₹${globalData.igstamount}`]);
    } else {
      summaryData.push(["CGST ", `₹${globalData.cgstamount}`]);
      summaryData.push(["SGST ", `₹${globalData.sgstamount}`]);
    }

    const sectionStartY = y;
    const boxTop = y;
    const totalTextX = 140;
    const verticalDividerX = totalTextX - 5;

    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || "#c8c8c8");
    doc.setLineWidth(0.1);
    doc.line(PADDING, boxTop, MARGIN_RIGHT, boxTop);

    let rightY = sectionStartY + 5;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.text("Total", totalTextX, rightY);
    doc.text(`₹${globalData?.grandtotal}`, MARGIN_RIGHT - 2, rightY, {
      align: "right",
    });

    rightY += 2;
    doc.line(totalTextX, rightY, MARGIN_RIGHT, rightY);

    rightY += 5;
    doc.setFontSize(9);
    doc.setTextColor(48, 48, 48);

    summaryData.forEach(([label, value], index) => {
      doc.text(label, totalTextX, rightY);
      doc.text(value, MARGIN_RIGHT - 2, rightY, { align: "right" });
      rightY += index === summaryData.length - 1 ? 0 : 4;
    });

    // // --- LEFT SIDE: IN WORDS ---
    let leftY = sectionStartY + 5;
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);
    doc.setTextColor(0);

    const labelStr = "IN WORDS : ";
    const fullAmountStr = `${labelStr}${globalData?.amountinwords || ""}`;
    const leftColumnWidth = verticalDividerX - PADDING - 6;

    const leftWrappedWords = doc.splitTextToSize(
      fullAmountStr,
      leftColumnWidth
    );

    leftWrappedWords.forEach((line, index) => {
      doc.text(line, PADDING + 2, leftY + index * 4);
    });

    const minBoxHeight = 25;
    const authSignatoryY = sectionStartY + minBoxHeight - 4;

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 30;
        const maxHeight = 12;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;

        // Position it right above the text
        doc.addImage(
          base64,
          signimg.endsWith(".png") ? "PNG" : "JPEG",
          PADDING + 2,
          authSignatoryY - imgH - 3,
          imgW,
          imgH
        );
      } catch (e) {
        console.warn("Signature load failed", e);
      }
    }

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    doc.setTextColor(0);
    doc.text("Authorized Signatory", PADDING + 2, authSignatoryY, {
      align: "left",
    });

    const leftSectionEndY = sectionStartY + minBoxHeight;
    const finalBoxBottom = Math.max(rightY, leftSectionEndY);

    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || "#c8c8c8");
    doc.line(PADDING, boxTop, PADDING, finalBoxBottom);
    doc.line(MARGIN_RIGHT, boxTop, MARGIN_RIGHT, finalBoxBottom);
    doc.line(PADDING, finalBoxBottom, MARGIN_RIGHT, finalBoxBottom);
    doc.line(verticalDividerX, boxTop, verticalDividerX, finalBoxBottom);

    y = finalBoxBottom;
    if (storeSettings?.negobillBranding) {
      const minGapY = y + 5;
      const bottomLimitY = HALF_PAGE_HEIGHT - 5;
      let finalBrandingY = Math.max(minGapY, bottomLimitY);
      const normalText = "Powered by ";
      const boldText = "NegoBill.com";
      doc.setFontSize(8);
      // doc.setTextColor(100, 100, 100);
      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);
      doc.text(normalText, MARGIN_LEFT, finalBrandingY);
      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, MARGIN_LEFT + normalW, finalBrandingY);
    }

    return doc;
  };
  //A4 bill commercial

  const generateBillHalfA4PDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const PADDING = 5;
    const HALF_PAGE_HEIGHT = 140; // Your target cut-off
    const USABLE_WIDTH = pageW - PADDING * 2; // Full width minus left/right padding
    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;
    const centerX = pageW / 2;
    let y = PADDING; // Start at exactly 5mm from the top
    const checkHalfPageOverflow = (currentY, neededSpace = 10) => {
      if (currentY + neededSpace > HALF_PAGE_HEIGHT - PADDING) {
        doc.addPage();
        return PADDING; // Reset Y for new page
      }
      return currentY;
    };

    const invoiceText =
      data.status === "CANCELLED" ? "CANCELLED" : "BILL RECEIPT";
    doc.setFontSize(9);
    doc.text(invoiceText, MARGIN_RIGHT, y + 2, { align: "right" });
    if (data?.salefrom?.image) {
      try {
        const imagePath = uRLs?.IMAGE_URL + "profile/" + data?.salefrom?.image;
        const logoBase64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(logoBase64);

        const maxWidth = 35;
        const maxHeight = 15;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const finalW = width * ratio;
        const finalH = height * ratio;

        // --- CHANGE HERE: Set logoX to MARGIN_LEFT instead of centering it ---
        const logoX = MARGIN_LEFT;

        doc.addImage(logoBase64, "PNG", logoX, y, finalW, finalH);

        // We don't necessarily want to push y down for the whole page yet
        // so the text can stay aligned with the logo area
        const logoBottom = y + finalH;

        // 2. DISPLAY COMPANY NAME (Still Centered)
        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(10); // Slightly larger for company name
        doc.setTextColor(0);
        doc.text(data.salefrom?.title || "", centerX, y + 3, {
          align: "center",
        });

        // 3. DISPLAY ADDRESS (Still Centered)
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(8);
        doc.setTextColor(60, 60, 60);

        const fromAddress = [
          [
            data.salefrom?.addressline1,
            data.salefrom?.addressline2,
            data.salefrom?.district,
            data.salefrom?.state,
            data.salefrom?.pincode,
          ]
            .filter(Boolean)
            .join(", "),
          [
            data.salefrom?.phone ? `Ph: ${data.salefrom.phone}` : "",
            data.salefrom?.gstnumber ? `GSTIN: ${data.salefrom.gstnumber}` : "",
          ]
            .filter(Boolean)
            .join(" | "),
        ].filter(Boolean);

        let addrY = y + 6;
        fromAddress.forEach((line) => {
          doc.text(line, centerX, addrY, { align: "center" });
          addrY += 4;
        });

        // Set y to the bottom of whichever is taller: the logo or the address text
        y = Math.max(logoBottom, addrY);
      } catch (e) {
        console.warn("Logo failed", e);
        y += 10; // Fallback spacing if logo fails
      }
    }

    y -= 2;

    doc.setDrawColor(
      selectedTheme?.templateTheme?.borderColor || [200, 200, 200]
    );
    doc.setLineWidth(0.3);
    doc.line(MARGIN_LEFT, y, MARGIN_RIGHT, y);
    y += 3;
    doc.setFontSize(7);
    const invoiceLabel = "Bill #: ";
    const invoiceValue = `${data.saleno || "-"}`;
    const dateLabel = "  |  Date: ";
    const dateValue = `${
      data.saledate ? DateConverter.ISOToDisplayFormat(data.saledate).date : "-"
    }`;

    const dateValueW = doc.getTextWidth(dateValue);
    const dateLabelW = doc.getTextWidth(dateLabel);
    const invoiceValueW = doc.getTextWidth(invoiceValue);
    const invoiceLabelW = doc.getTextWidth(invoiceLabel);

    const totalWidth = invoiceLabelW + invoiceValueW + dateLabelW + dateValueW;

    let currentX = MARGIN_RIGHT - totalWidth;
    doc.setFont("Inter-Regular", "normal");
    doc.text(invoiceLabel, currentX, y);
    currentX += invoiceLabelW;

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceValue, currentX, y);
    currentX += invoiceValueW;

    doc.setFont("Inter-Regular", "normal");
    doc.text(dateLabel, currentX, y);
    currentX += dateLabelW;

    doc.setFont("Inter-Bold", "bold");
    doc.text(dateValue, currentX, y);

    y += 2;

    const toDetailsLine = [
      data.saleto?.name || "-",
      [
        data.saleto?.addressline1,
        data.saleto?.addressline2,
        data.saleto?.district,
        data.saleto?.state,
        data.saleto?.pincode,
      ],
      [
        data.saleto?.gstnumber ? `GSTIN: ${data.saleto.gstnumber}` : "",
        data.saleto?.phone ? `Mobile: ${data.saleto.phone}` : "",
      ]
        .filter(Boolean)
        .join(" | "),
    ]
      .filter(Boolean)
      .join("\n");

    // y += 2;
    const colWidth = pageW - PADDING * 2;

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.text("Customer Details:", PADDING, y);
    const wrappedBilling = doc.splitTextToSize(toDetailsLine, colWidth - 5);

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    doc.text(wrappedBilling, PADDING, y + 4);

    const billingHeight = wrappedBilling.length * 3.5;
    y += Math.max(billingHeight) + 2;

    const leftBoxX = 8;

    /* -------------------------------------------------
       PRODUCT TABLE1
    ------------------------------------------------- */
    autoTable(doc, {
      startY: y + 1,
      theme: "plain",
      rowPageBreak: "avoid",

      margin: {
        top: PADDING,
        left: PADDING,
        right: PADDING,
        bottom: pageH - HALF_PAGE_HEIGHT + PADDING,
      },
      pageBreak: "auto",
      styles: {
        font: "Inter-Regular",
        fontSize: 7,
        cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
        valign: "middle",
        lineWidth: 0,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        textColor: [0, 0, 0],
      },
      headStyles: {
        font: "Inter-Bold",
        fontSize: 8,
        fillColor: selectedTheme?.templateTheme?.primaryColor || [20, 40, 100],
        textColor: selectedTheme?.templateTheme?.foregroundColor || [0, 0, 0],
        lineWidth: { top: 0.5, bottom: 0.5 },
        lineColor: selectedTheme?.templateTheme?.borderColor,
      },
      head: [["#", "Item", "MRP", "Selling Price", "Qty", "Amount"]],
      body: data.saleitems.map((it, i) => {
        const itemDesc = it.hsnsac
          ? `${it.title}\nHSN: ${it.hsnsac}`
          : it.title;
        return [
          i + 1,
          itemDesc,
          formatCurrency(
            CurrencyConverter.toCurrency(it.mrp || 0, "INR"),
            "INR",
            true,
            true
          ),
          formatCurrency(
            CurrencyConverter.toCurrency(it.baseprice || 0, "INR"),
            "INR",
            true,
            true
          ),
          `${it.quantity} `, //Pcs
          formatCurrency(
            CurrencyConverter.toCurrency(it.lineGrandTotal || 0, "INR"),
            "INR",
            true,
            true
          ),
        ];
      }),
      columnStyles: {
        0: { cellWidth: 10, halign: "center" }, // S.No
        1: { cellWidth: "auto", halign: "left" }, // Flexible Description
        2: { cellWidth: 35, halign: "right" }, // Right-aligned Price
        3: { cellWidth: 30, halign: "right" },
        4: { cellWidth: 20, halign: "right" }, // Right-aligned Price
        5: { cellWidth: 25, halign: "right" }, // Amount
      },
      didParseCell: function (data) {
        if (data.section === "head") {
          data.cell.styles.lineWidth = { top: 0.2, bottom: 0.2 };
          const colId = data.column.index;
          if (colId === 0) data.cell.styles.halign = "center";
          if (colId === 2 || colId === 3 || colId === 4 || colId === 5)
            data.cell.styles.halign = "right";

          if (data.column.index === 0) {
            data.cell.styles.lineWidth = {
              ...data.cell.styles.lineWidth,
              left: 0.2,
            };
          }

          if (data.column.index === 5) {
            data.cell.styles.lineWidth = {
              ...data.cell.styles.lineWidth,
              right: 0.2,
            };
          }
        }
        if (data.section === "body") {
          const colId = data.column.index;
          let lines = { bottom: 0 };

          if (colId === 0) {
            lines.left = 0.1;
          }

          if (colId === 5) {
            lines.right = 0.1;
          }
          data.cell.styles.lineWidth = lines;
        }
      },

      didDrawPage: function (data) {
        const finalY = data.cursor.y;
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
        doc.line(PADDING, finalY, pageW - PADDING, finalY); // Bottom horizontal line
      },
    });

    /* -------------------------------------------------
  //    TOTALS & GST SECTION (Split Row)
  // ------------------------------------------------- */

    y = doc.lastAutoTable.finalY;
    // y = checkHalfPageOverflow(y, 35);
    const isInterState =
      data?.salefrom?.statecode &&
      data?.saleto?.statecode &&
      data?.salefrom?.statecode !== data?.saleto?.statecode;

    //  const summaryData = [
    //     ["Total Amount Before Tax",  formatCurrency((CurrencyConverter.toCurrency(data.totalbaseprice|| 0, "INR")), "INR", true, true)]];
    //   if (isInterState) {
    //     summaryData.push(["IGST ", formatCurrency((CurrencyConverter.toCurrency(data.igstamount|| 0, "INR")), "INR", true, true)]);
    //     } else {
    //     summaryData.push(["CGST ", formatCurrency((CurrencyConverter.toCurrency(data.cgstamount|| 0, "INR")), "INR", true, true)]);
    //     summaryData.push(["SGST ",  formatCurrency((CurrencyConverter.toCurrency(data.sgstamount|| 0, "INR")), "INR", true, true)]);
    //     }

    const sectionStartY = y;
    const boxTop = y;
    const totalTextX = 140;
    const verticalDividerX = totalTextX - 5;

    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || "#c8c8c8");
    doc.setLineWidth(0.1);
    doc.line(PADDING, boxTop, MARGIN_RIGHT, boxTop);

    let rightY = sectionStartY + 5;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.text("Total", totalTextX, rightY);
    doc.text(
      `${formatCurrency(
        CurrencyConverter.toCurrency(data?.grandtotal || 0, "INR"),
        "INR",
        true,
        true
      )}`,
      MARGIN_RIGHT - 2,
      rightY,
      { align: "right" }
    );

    rightY += 2;
    doc.line(totalTextX, rightY, MARGIN_RIGHT, rightY);

    // rightY += 5;
    // doc.setFontSize(9);
    // doc.setTextColor(48, 48, 48);

    // summaryData.forEach(([label, value], index) => {
    //     doc.text(label, totalTextX, rightY);
    //     doc.text(value, MARGIN_RIGHT - 2, rightY, { align: "right" });
    //     rightY += (index === summaryData.length - 1) ? 0 : 4;
    // });

    // // --- LEFT SIDE: IN WORDS ---
    let leftY = sectionStartY + 5;
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);
    doc.setTextColor(0);

    const labelStr = "IN WORDS : ";
    const fullAmountStr = `${labelStr}${data?.amountinwords || ""}`;
    const leftColumnWidth = verticalDividerX - PADDING - 6;

    const leftWrappedWords = doc.splitTextToSize(
      fullAmountStr,
      leftColumnWidth
    );

    leftWrappedWords.forEach((line, index) => {
      doc.text(line, PADDING + 2, leftY + index * 4);
    });

    const minBoxHeight = 25;
    const authSignatoryY = sectionStartY + minBoxHeight - 4;

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 30;
        const maxHeight = 12;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;

        // Position it right above the text
        doc.addImage(
          base64,
          signimg.endsWith(".png") ? "PNG" : "JPEG",
          PADDING + 2,
          authSignatoryY - imgH - 3,
          imgW,
          imgH
        );
      } catch (e) {
        console.warn("Signature load failed", e);
      }
    }

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    doc.setTextColor(0);
    doc.text("Authorized Signatory", PADDING + 2, authSignatoryY, {
      align: "left",
    });

    const leftSectionEndY = sectionStartY + minBoxHeight;
    const finalBoxBottom = Math.max(rightY, leftSectionEndY);

    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || "#c8c8c8");
    doc.line(PADDING, boxTop, PADDING, finalBoxBottom);
    doc.line(MARGIN_RIGHT, boxTop, MARGIN_RIGHT, finalBoxBottom);
    doc.line(PADDING, finalBoxBottom, MARGIN_RIGHT, finalBoxBottom);
    doc.line(verticalDividerX, boxTop, verticalDividerX, finalBoxBottom);

    y = finalBoxBottom;
    if (storeSettings?.negobillBranding) {
      const minGapY = y + 5;
      const bottomLimitY = HALF_PAGE_HEIGHT - 5;
      let finalBrandingY = Math.max(minGapY, bottomLimitY);
      const normalText = "Powered by ";
      const boldText = "NegoBill.com";
      doc.setFontSize(8);
      // doc.setTextColor(100, 100, 100);
      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);
      doc.text(normalText, MARGIN_LEFT, finalBrandingY);
      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, MARGIN_LEFT + normalW, finalBrandingY);
    }

    return doc;
  };
  const handleDownload = async (data) => {
    setDownload(true);
    const { salemode, saleno } = data || {};

    let doc;

    if (salemode?.toUpperCase() === "BILL") {
      doc = await generateBillHalfA4PDF();
    } else {
      doc = await generateinvoiceHalfA4PDF();
    }

    const filenamePrefix = formatTrackMode(salemode)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };

  const handlePrint = async (data, overrideSize = null) => {
    setPrint(true);
    try {
      if (!checkNetwork()) return;

      const paperSize = overrideSize || selectedSize;
      const upperMode = data?.salemode?.toUpperCase();
      let doc;

      if (paperSize === "BILL") {
        doc = await generateBillHalfA4PDF();
      } else {
        doc = await generateinvoiceHalfA4PDF();
      }

      const blob = doc.output("blob");
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        const printWindow = iframe.contentWindow;

        const cleanup = () => {
          // Remove iframe safely
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }

          // Remove listeners
          window.removeEventListener("afterprint", cleanup);
          printWindow.matchMedia("(print)").removeListener(handlePrintState);
        };

        const handlePrintState = (mql) => {
          // WHEN PRINT PREVIEW CLOSES (printed OR canceled)
          if (!mql.matches) {
            setTimeout(cleanup, 50); // small delay makes Chrome stable
          }
        };

        // Watch print state
        printWindow.matchMedia("(print)").addListener(handlePrintState);

        // Also catch Chrome's afterprint
        window.addEventListener("afterprint", cleanup);
        setPrint(false);
        setTimeout(() => {
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElementList = [].slice.call(
              document.querySelectorAll(".dropdown-toggle")
            );
            dropdownElementList.map(function (dropdownToggleEl) {
              return new window.bootstrap.Dropdown(dropdownToggleEl);
            });
          }
        }, 100);
        // Trigger printing
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    } catch (error) {
      setPrint(false);
      handleError(error, showAlert);
      return false;
    }
    // finally {
    //   setPrint(false);
    // }
  };

  useEffect(() => {
    setData(isViewData);
  }, [isViewData]);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  const formatCurrency2 = (value) => {
    const amount = CurrencyConverter.toCurrency(value, "INR");
    const formatted = Math.abs(amount).toLocaleString("en-IN", {
      minimumFractionDigits: 0, // Don't force .00
      maximumFractionDigits: 2, // Show up to 2 decimals if they exist (like .78)
    });

    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint(data);
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);

  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings]);
  const grantotal = CurrencyConverter.toCurrency(data?.grandtotal || 0, "INR");
  const paidamount = CurrencyConverter.toCurrency(data?.paidamount || 0, "INR");
  const balanceDue = grantotal - paidamount;
  useEffect(() => {
    const upi = storeSettings?.paymentSettings?.upiId;

    const name = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
    if (!upi) return; // skip until upi is available

    const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
    console.log("ip", upiUrl);
    QRCode.toDataURL(upiUrl)
      .then((url) => {
        setQrCodeDataUrl(url);
      })
      .catch((err) => {
        console.error("QR Code generation failed: ", err);
      });
  }, [
    storeSettings?.paymentSettings?.upiId,
    storeSettings?.paymentSettings?.bankDetails?.beneficiaryName,
  ]);
  const isInterState =
    data?.salefrom?.statecode &&
    data?.saleto?.statecode &&
    data?.salefrom?.statecode !== data?.saleto?.statecode;

  return (
    <>
      <div className="invoice-scale">
        {selectedSize === "INVOICE" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in">
                  <div
                    className="pdfcontent"
                    style={{
                      borderBottom: "1px solid #ccc",
                      paddingBottom: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <div style={{ flex: "1", textAlign: "left" }}>
                        {("/assets/images/logo-light.png" ||
                          settings?.saleProfileData?.image) && (
                          <img
                            src={
                              settings?.saleProfileData?.image
                                ? uRLs.IMAGE_URL +
                                  "profile/" +
                                  settings?.saleProfileData?.image
                                : "/assets/images/logo-light.png"
                            }
                            className="img-rounded logo"
                            height="50"
                            alt="Logo"
                          />
                        )}
                      </div>

                      <div
                        style={{
                          flex: "2",
                          textAlign: "center",
                          fontSize: "12px",
                          lineHeight: "16px",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "700",
                            fontSize: "16px",
                            textTransform: "uppercase",
                          }}
                        >
                          {settings?.saleProfileData?.title}
                        </div>
                        <div>
                          {settings?.saleProfileData?.addressline1 || ""}{" "}
                          {settings?.saleProfileData?.addressline2 || ""}{" "}
                          {settings?.saleProfileData?.district || ""}{" "}
                          {settings?.saleProfileData?.country || ""} -{" "}
                          {settings?.saleProfileData?.pincode || ""}
                        </div>
                        <div style={{ fontSize: "11px" }}>
                          Ph: {settings?.saleProfileData?.phone}{" "}
                          {settings?.saleProfileData?.email &&
                            `| Email: ${settings?.saleProfileData?.email}`}
                        </div>
                      </div>

                      <div style={{ flex: "1", textAlign: "right" }}>
                        <div
                          style={{
                            fontWeight: "600",
                            fontSize: "16px",
                            textTransform: "uppercase",
                          }}
                        >
                          {isViewData?.salemode
                            ? formatTrackMode(isViewData?.salemode)
                            : "TAX INVOICE"}
                        </div>
                        {isViewData?.status === "CANCELLED" && (
                          <div
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            {isViewData?.status}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-9 pe-1 ">
                      <table width="100%" className="pdfcontent">
                        <tbody>
                          <tr>
                            <td width="100%" style={{ verticalAlign: "top" }}>
                              {globalData?.saleto && (
                                <div
                                  style={{
                                    textAlign: "left",
                                    marginTop: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "700",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    Customer Details:
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "12px",
                                      lineHeight: "1.4",
                                      color: "#333",
                                    }}
                                  >
                                    <div style={{ marginBottom: "1px" }}>
                                      {globalData?.saleto?.name}
                                    </div>
                                    <div style={{ marginBottom: "1px" }}>
                                      {globalData?.saleto?.addressline1 &&
                                        `${globalData?.saleto?.addressline1}, `}
                                      {globalData?.saleto?.addressline2 &&
                                        `${globalData?.saleto?.addressline2}, `}
                                      {globalData?.saleto?.district &&
                                        `${globalData?.saleto?.district}, `}
                                      {globalData?.saleto?.state &&
                                        `${globalData?.saleto?.state}, `}
                                      {globalData?.saleto?.country}
                                      {globalData?.saleto?.pincode &&
                                        ` - ${globalData?.saleto?.pincode}`}
                                    </div>
                                    <div>
                                      {globalData?.saleto?.gstnumber && (
                                        <span>
                                          GSTIN: {globalData?.saleto?.gstnumber}
                                        </span>
                                      )}
                                      {globalData?.saleto?.gstnumber &&
                                        globalData?.saleto?.phone && (
                                          <span style={{ margin: "0 5px" }}>
                                            {" "}
                                            |{" "}
                                          </span>
                                        )}
                                      {globalData?.saleto?.phone && (
                                        <span>
                                          Mobile: {globalData?.saleto?.phone}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-3 pe-1 ">
                      <div className="tm_invoice_info tm_mb20 text_end">
                        <div className="tm_invoice_info_list ">
                          <p className="tm_invoice_number tm_m0 mb-0 mt-0">
                            <b className="tm_primary_color">Invoice No: </b>{" "}
                            {globalData?.saleno}
                          </p>
                          <p className="tm_invoice_date tm_m0 mt-0">
                            <b className="tm_primary_color"> Date: </b>{" "}
                            {saleTime?.date}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <table
                    className="mt-3"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr>
                        <th
                          className=""
                          style={{
                            width: "20px",
                            textAlign: "center",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderLeft: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderRight: "none",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                          }}
                        >
                          {" "}
                          #{" "}
                        </th>

                        {/* Item Column: Top and Right only */}
                        <th
                          className=""
                          style={{
                            textAlign: "left",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                          }}
                        >
                          {" "}
                          Item{" "}
                        </th>
                        <th
                          className=""
                          style={{
                            textAlign: "right",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                          }}
                        >
                          {" "}
                          MRP{" "}
                        </th>

                        <th
                          className=""
                          style={{
                            textAlign: "right",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                          }}
                        >
                          {" "}
                          Selling Price{" "}
                        </th>
                        <th
                          className=""
                          style={{
                            textAlign: "right",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                          }}
                        >
                          {" "}
                          Qty{" "}
                        </th>
                        <th
                          className=""
                          style={{
                            textAlign: "right",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            // borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                          }}
                        >
                          Landing Cost
                        </th>
                        <th
                          className=""
                          style={{
                            textAlign: "right",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                          }}
                        >
                          {" "}
                          Amount{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {globalData.saleitems?.map((item, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              width: "5%",
                              borderLeft: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              width: "45%",
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "left",
                              paddingLeft: "5px", // Space for the title
                            }}
                          >
                            {item.title}
                          </td>
                          <td
                            style={{
                              width: "12%",
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              paddingRight: "5px", // Fix for MRP alignment
                            }}
                          >
                            {item.mrp}
                          </td>
                          <td
                            style={{
                              width: "15%",
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              paddingRight: "5px", // Fix for Selling Price alignment
                            }}
                          >
                            ₹{item.baseprice}
                          </td>
                          <td
                            style={{
                              width: "8%",
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              paddingRight: "5px", // Fix for Qty alignment
                            }}
                          >
                            {item.quantity}
                            {(() => {
                              const unitCode = item?.isSecondaryUnit
                                ? item?.unitConfig?.secondaryUnitCode
                                : item?.unitConfig?.primaryUnitCode;
                              return unitCode || "";
                            })()}
                          </td>
                          <td
                            style={{
                              width: "15%",
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              paddingRight: "5px", // This ensures the Amount text doesn't touch the outer border
                            }}
                          >
                            ₹{item.lineTotalLandingCost}
                          </td>
                          <td
                            style={{
                              width: "15%",
                              borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              paddingRight: "5px", // This ensures the Amount text doesn't touch the outer border
                            }}
                          >
                            ₹{item.lineGrandTotal}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div
                    className="row"
                    style={{
                      // Matches the table side borders
                      border: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                      borderTop: "none",
                      display: "flex",
                      margin: "0",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        flex: 1, // Takes up remaining space
                        padding: "10px",
                        borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`, // Match table inner border weight
                      }}
                    >
                      <p
                        style={{
                          fontSize: "11px",
                          fontWeight: "bold",
                          margin: "0",
                        }}
                      >
                        IN WORDS : {globalData?.amountinwords}
                      </p>
                      <div style={{ marginTop: "20px" }}>
                        {storeSettings?.invoiceSettings?.signature && (
                          <img
                            src={
                              uRLs.IMAGE_URL +
                              storeSettings?.invoiceSettings?.signature
                            }
                            width={120}
                            alt="signature"
                          />
                        )}
                        <p
                          style={{
                            fontSize: "10px",
                            margin: "0",
                            fontWeight: "600",
                          }}
                        >
                          Authorized Signatory
                        </p>
                      </div>
                    </div>
                    <div style={{ width: "300px", padding: "0" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "5px 10px",
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          // backgroundColor: "#f8f9fa"
                        }}
                      >
                        <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                          Total
                        </span>
                        <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                          {formatCurrency(
                            CurrencyConverter.toCurrency(
                              data.grandtotal || 0,
                              "INR"
                            ),
                            "INR",
                            true,
                            true
                          )}
                        </span>
                      </div>

                      <div
                        style={{
                          padding: "8px 10px",
                          fontSize: "12px",
                          lineHeight: "1.6",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Total Amount Before Tax</span>
                          <span>
                            {formatCurrency(
                              CurrencyConverter.toCurrency(
                                data.totalbaseprice || 0,
                                "INR"
                              ),
                              "INR",
                              true,
                              true
                            )}
                          </span>
                        </div>

                        {isInterState ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>IGST</span>
                            <span>
                              {formatCurrency(
                                CurrencyConverter.toCurrency(
                                  data.igstamount || 0,
                                  "INR"
                                ),
                                "INR",
                                true,
                                true
                              )}
                            </span>
                          </div>
                        ) : (
                          <>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <span>CGST</span>
                              <span>
                                {formatCurrency(
                                  CurrencyConverter.toCurrency(
                                    data.cgstamount || 0,
                                    "INR"
                                  ),
                                  "INR",
                                  true,
                                  true
                                )}
                              </span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <span>SGST</span>
                              <span>
                                {formatCurrency(
                                  CurrencyConverter.toCurrency(
                                    data.sgstamount || 0,
                                    "INR"
                                  ),
                                  "INR",
                                  true,
                                  true
                                )}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>{" "}
                  {storeSettings?.negobillBranding && (
                    <>
                      <div className="mt-5 fs-20 d-flex justify-content-left fw-bold">
                        <span>Powered By NegoBill.com</span>
                      </div>
                    </>
                  )}
                  <table width="100%"></table>
                </div>
              </div>
            </div>
          </div>
        ) : selectedSize === "BILL" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in">
                  <div
                    className="pdfcontent"
                    style={{
                      borderBottom: "1px solid #ccc",
                      paddingBottom: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <div style={{ flex: "1", textAlign: "left" }}>
                        {("/assets/images/logo-light.png" ||
                          settings?.saleProfileData?.image) && (
                          <img
                            src={
                              settings?.saleProfileData?.image
                                ? uRLs.IMAGE_URL +
                                  "profile/" +
                                  settings?.saleProfileData?.image
                                : "/assets/images/logo-light.png"
                            }
                            className="img-rounded logo"
                            height="50"
                            alt="Logo"
                          />
                        )}
                      </div>

                      <div
                        style={{
                          flex: "2",
                          textAlign: "center",
                          fontSize: "12px",
                          lineHeight: "16px",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "700",
                            fontSize: "16px",
                            textTransform: "uppercase",
                          }}
                        >
                          {settings?.saleProfileData?.title}
                        </div>
                        <div>
                          {settings?.saleProfileData?.addressline1 || ""}{" "}
                          {settings?.saleProfileData?.addressline2 || ""}{" "}
                          {settings?.saleProfileData?.district || ""}{" "}
                          {settings?.saleProfileData?.country || ""} -{" "}
                          {settings?.saleProfileData?.pincode || ""}
                        </div>
                        <div style={{ fontSize: "11px" }}>
                          Ph: {settings?.saleProfileData?.phone}{" "}
                          {settings?.saleProfileData?.email &&
                            `| Email: ${settings?.saleProfileData?.email}`}
                        </div>
                      </div>

                      <div style={{ flex: "1", textAlign: "right" }}>
                        <div
                          style={{
                            fontWeight: "600",
                            fontSize: "16px",
                            textTransform: "uppercase",
                          }}
                        >
                          {isViewData?.salemode
                            ? formatTrackMode(isViewData?.salemode)
                            : "BILL RECEIPT"}
                        </div>
                        {isViewData?.status === "CANCELLED" && (
                          <div
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            {isViewData?.status}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-9 pe-1 ">
                      <table width="100%" className="pdfcontent">
                        <tbody>
                          <tr>
                            <td width="100%" style={{ verticalAlign: "top" }}>
                              {isViewData?.saleto && (
                                <div
                                  style={{
                                    textAlign: "left",
                                    marginTop: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "700",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    Customer Details:
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "12px",
                                      lineHeight: "1.4",
                                      color: "#333",
                                    }}
                                  >
                                    <div style={{ marginBottom: "1px" }}>
                                      {isViewData?.saleto?.name}
                                    </div>
                                    <div style={{ marginBottom: "1px" }}>
                                      {isViewData?.saleto?.addressline1 &&
                                        `${isViewData?.saleto?.addressline1}, `}
                                      {isViewData?.saleto?.addressline2 &&
                                        `${isViewData?.saleto?.addressline2}, `}
                                      {isViewData?.saleto?.district &&
                                        `${isViewData?.saleto?.district}, `}
                                      {isViewData?.saleto?.state &&
                                        `${isViewData?.saleto?.state}, `}
                                      {isViewData?.saleto?.country}
                                      {isViewData?.saleto?.pincode &&
                                        ` - ${isViewData?.saleto?.pincode}`}
                                    </div>
                                    <div>
                                      {isViewData?.saleto?.gstnumber && (
                                        <span>
                                          GSTIN: {isViewData?.saleto?.gstnumber}
                                        </span>
                                      )}
                                      {isViewData?.saleto?.gstnumber &&
                                        isViewData?.saleto?.phone && (
                                          <span style={{ margin: "0 5px" }}>
                                            {" "}
                                            |{" "}
                                          </span>
                                        )}
                                      {isViewData?.saleto?.phone && (
                                        <span>
                                          Mobile: {isViewData?.saleto?.phone}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-3 pe-1 ">
                      <div className="tm_invoice_info tm_mb20 text_end">
                        <div className="tm_invoice_info_list ">
                          <p className="tm_invoice_number tm_m0 mb-0 mt-0">
                            <b className="tm_primary_color">Bil No: </b>{" "}
                            {isViewData?.saleno}
                          </p>
                          <p className="tm_invoice_date tm_m0 mt-0">
                            <b className="tm_primary_color"> Date: </b>{" "}
                            {saleTime?.date}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <table
                    className="mt-3"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            width: "20px",
                            textAlign: "center",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderLeft: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderRight: "none",
                            color:
                              selectedTheme?.templateTheme?.foregroundColor,
                            backgroundColor:
                              selectedTheme?.templateTheme?.primaryColor,
                          }}
                        >
                          {" "}
                          #{" "}
                        </th>

                        {/* Item Column: Top and Right only */}
                        <th
                          style={{
                            textAlign: "left",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            color:
                              selectedTheme?.templateTheme?.foregroundColor,
                            backgroundColor:
                              selectedTheme?.templateTheme?.primaryColor,
                          }}
                        >
                          {" "}
                          Item{" "}
                        </th>
                        <th
                          style={{
                            textAlign: "right",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            color:
                              selectedTheme?.templateTheme?.foregroundColor,
                            backgroundColor:
                              selectedTheme?.templateTheme?.primaryColor,
                          }}
                        >
                          {" "}
                          MRP{" "}
                        </th>

                        <th
                          style={{
                            textAlign: "right",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            color:
                              selectedTheme?.templateTheme?.foregroundColor,
                            backgroundColor:
                              selectedTheme?.templateTheme?.primaryColor,
                          }}
                        >
                          {" "}
                          Selling Price{" "}
                        </th>
                        <th
                          style={{
                            textAlign: "right",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            color:
                              selectedTheme?.templateTheme?.foregroundColor,
                            backgroundColor:
                              selectedTheme?.templateTheme?.primaryColor,
                          }}
                        >
                          {" "}
                          Qty{" "}
                        </th>
                        <th
                          style={{
                            textAlign: "right",
                            borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            color:
                              selectedTheme?.templateTheme?.foregroundColor,
                            backgroundColor:
                              selectedTheme?.templateTheme?.primaryColor,
                          }}
                        >
                          {" "}
                          Amount{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.saleitems?.map((item, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              width: "5%",
                              borderLeft: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              width: "45%",
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "left",
                              paddingLeft: "5px", // Space for the title
                            }}
                          >
                            {item.title}
                          </td>
                          <td
                            style={{
                              width: "12%",
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              paddingRight: "5px", // Fix for MRP alignment
                            }}
                          >
                            {formatCurrency(
                              CurrencyConverter.toCurrency(
                                item.mrp || 0,
                                "INR"
                              ),
                              "INR",
                              true,
                              true
                            )}
                          </td>
                          <td
                            style={{
                              width: "15%",
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              paddingRight: "5px", // Fix for Selling Price alignment
                            }}
                          >
                            {formatCurrency(
                              CurrencyConverter.toCurrency(
                                item.baseprice || 0,
                                "INR"
                              ),
                              "INR",
                              true,
                              true
                            )}
                          </td>
                          <td
                            style={{
                              width: "8%",
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              paddingRight: "5px", // Fix for Qty alignment
                            }}
                          >
                            {item.quantity}
                          </td>
                          <td
                            style={{
                              width: "15%",
                              borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              paddingRight: "5px", // This ensures the Amount text doesn't touch the outer border
                            }}
                          >
                            {formatCurrency(
                              CurrencyConverter.toCurrency(
                                item.lineGrandTotal || 0,
                                "INR"
                              ),
                              "INR",
                              true,
                              true
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div
                    className="row"
                    style={{
                      // Matches the table side borders
                      border: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                      borderTop: "none",
                      display: "flex",
                      margin: "0",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        flex: 1, // Takes up remaining space
                        padding: "10px",
                        borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`, // Match table inner border weight
                      }}
                    >
                      <p
                        style={{
                          fontSize: "11px",
                          fontWeight: "bold",
                          margin: "0",
                        }}
                      >
                        IN WORDS : {isViewData?.amountinwords}
                      </p>
                      <div style={{ marginTop: "20px" }}>
                        {storeSettings?.invoiceSettings?.signature && (
                          <img
                            src={
                              uRLs.IMAGE_URL +
                              storeSettings?.invoiceSettings?.signature
                            }
                            width={120}
                            alt="signature"
                          />
                        )}
                        <p
                          style={{
                            fontSize: "10px",
                            margin: "0",
                            fontWeight: "600",
                          }}
                        >
                          Authorized Signatory
                        </p>
                      </div>
                    </div>
                    <div style={{ width: "300px", padding: "0" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "5px 10px",
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                          Total
                        </span>
                        <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                          {formatCurrency(
                            CurrencyConverter.toCurrency(
                              data.grandtotal || 0,
                              "INR"
                            ),
                            "INR",
                            true,
                            true
                          )}
                        </span>
                      </div>

                      <div
                        style={{
                          padding: "8px 10px",
                          fontSize: "12px",
                          lineHeight: "1.6",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Total Amount Before Tax</span>
                          <span>
                            {formatCurrency(
                              CurrencyConverter.toCurrency(
                                data.totalbaseprice || 0,
                                "INR"
                              ),
                              "INR",
                              true,
                              true
                            )}
                          </span>
                        </div>

                        {/* {isInterState ? (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>IGST</span>
          <span>{formatCurrency((CurrencyConverter.toCurrency(data.igstamount|| 0, "INR")), "INR", true, true)}</span>
        </div>
      ) : (
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>CGST</span>
            <span>{formatCurrency((CurrencyConverter.toCurrency(data.cgstamount|| 0, "INR")), "INR", true, true)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>SGST</span>
            <span>{formatCurrency((CurrencyConverter.toCurrency(data.sgstamount|| 0, "INR")), "INR", true, true)}</span>
          </div>
        </>
      )} */}
                      </div>
                    </div>
                  </div>{" "}
                  {storeSettings?.negobillBranding && (
                    <>
                      <div className="mt-5 fs-20 d-flex justify-content-left fw-bold">
                        <span>Powered By NegoBill.com</span>
                      </div>
                    </>
                  )}
                  <table width="100%"></table>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </div>

      <div
        className="modal-footer d-block mt-2"
        style={{
          position: "sticky",
          bottom: -4,
          background: "#fff",
          zIndex: 10,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        {payment && <div className="fw-600 mb-2 font-14">PAYMENT SUMMARY</div>}
        {payment && (
          <table
            className="items table-bordered mb-3"
            width="100%"
            cellPadding="4"
          >
            <tbody className="text-center">
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor: isViewData.cashamount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                  }}
                  onClick={(e) => {
                    if (isViewData.cashamount > 0) {
                      cashRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.cashamount > 0
                        ? "badge rounded-pill bg-label-moon d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px", fontSize: "12px" }}
                  >
                    CASH
                    {isViewData?.cashamount > 0 && <ShowIcon/>}
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  CARD
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  ONLINE
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  UPI
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor:
                      isViewData?.paylateramount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                    fontSize: "12px",
                  }}
                  onClick={(e) => {
                    if (isViewData?.paylateramount > 0) {
                      paylaterRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.paylateramount > 0
                        ? "badge rounded-pill bg-label-fire d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px" }}
                  >
                    PAYLATER
                    {isViewData?.paylateramount > 0 && (
                      <ShowIcon iClass={"ms-1"} />
                    )}
                  </div>
                </th>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cashamount || 0) -
                      (isViewData?.cashchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cardamount || 0) -
                      (isViewData?.cardchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.onlineamount || 0) -
                      (isViewData?.onlinechange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.upiamount || 0) - (isViewData?.upichange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.paylateramount || 0) -
                      (isViewData?.paylaterchange || 0)
                  )}
                </td>
              </tr>
            </tbody>
            <CashButton
              ref={cashRef}
              trackId={isViewData?.boxCashInfo?.trackid}
              trackMode={isViewData?.boxCashInfo?.trackmode}
            />
            <PayLaterButton
              ref={paylaterRef}
              trackId={isViewData?.paylaterInfo?.trackid}
              customerId={isViewData?.paylaterInfo?.customerid}
              trackMode={isViewData?.paylaterInfo?.trackmode}
            />
          </table>
        )}
        {downloadbtn && (
          <div className="my-2 d-flex gap-2">
            <div className="btn-group text-right align-items-center">
              {print ? (
                <button
                  className="btn bg-label-animal btn-sm pb-0 font-12"
                  disabled
                >
                  <CircularProgress size={12} className="text-white" />
                </button>
              ) : (
                <>
                  <button
                    onClick={() => handlePrint(data)}
                    className="btn bg-label-animal shadow-none btn-sm font-12"
                    id="printreceiptbtn"
                  >
                    <PrinterIcon iClass={"ms-12"}/> Print
                  </button>
                </>
              )}
            </div>

            {download ? (
              <button
                className="btn btn-warning btn-sm pb-0 text-right"
                disabled
              >
                <CircularProgress size={18} className="text-black" />
              </button>
            ) : (
              <button
                className="btn btn-warning btn-sm text-right"
                id="generatebillpdfbtn"
                onClick={() => handleDownload(data)}
              >
                <DownloadIcon iClass={"fs-15"}/>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default HalfA4_2;
